import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay, A11y } from 'swiper';
import { useMediaQuery } from 'react-responsive';
import Review from '../review/review';
import { reviews } from '../../const';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import styles from './reviews.module.scss';


SwiperCore.use([Autoplay, A11y, Pagination, Navigation]);

function Reviews() {

  const isMobile = useMediaQuery({
    query: '(max-width: 743px)',
  });

  return (
    <div className={styles.reviews} id="reviews">
      <h2 className={styles.title}>Отзывы</h2>
      <div className={styles.wrapper}>
        <iframe
          style={{ width: '100%', height: '100%', border: '1px solid #e6e6e6', borderRadius: '8px', boxSizing: 'border-box' }}
          src="https://yandex.ru/maps-reviews-widget/154934287484?comments"
          title="Отзывы о Массажист Кая М."
        />
        <a
          href="https://yandex.ru/maps/org/massazhist_kaya_m_/154934287484/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            boxSizing: 'border-box',
            textDecoration: 'none',
            color: '#b3b3b3',
            fontSize: '10px',
            fontFamily: 'YS Text, sans-serif',
            padding: '0 16px',
            position: 'absolute',
            bottom: '11px',
            width: '100%',
            textAlign: 'center',
            left: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block',
            maxHeight: '20px',
            whiteSpace: 'nowrap'
          }}
        >
          Массажист Кая М. на карте Калужской области — Яндекс Карты
        </a>
      </div>
      <Swiper
        slidesPerView={1}
        a11y
        loop
        navigation={isMobile && true}
        pagination={isMobile ? false : { clickable: true }}
        autoplay={{ 'delay': 10000, 'disableOnInteraction': false }}
      >
        {
          reviews.map((review) => (
            <SwiperSlide key={review.id}>
              <Review review={review} />
            </SwiperSlide>
          ))
        }
      </Swiper>
    </div >

  );
}

export default Reviews;
